import { createCustomEnum } from "../customEnum";

const FeeTemplatesTypes = createCustomEnum({
	None: {
		value: 0,
		name: "None",
		displayName: "None",
	},
	InterchangePlus: {
		value: 1,
		name: "InterchangePlus",
		displayName: "Interchange Plus",
	},

	FlatRate: {
		value: 2,
		name: "FlatRate",
		displayName: "Flat Rate",
	},
	ThreeTier: {
		value: 3,
		name: "ThreeTier",
		displayName: "3-Tier",
	},
	ERR: {
		value: 4,
		name: "ERR",
		displayName: "ERR",
	},
	AdditionalFees: {
		value: 5,
		name: "AdditionalFees",
		displayName: "Additional Fees",
	},
	MonthlyFees: {
		value: 6,
		name: "MonthlyFees",
		displayName: "Monthly Fees",
	},
	Arise: {
		value: 7,
		name: "Arise",
		displayName: "Arise",
	},
	ACH: {
		value: 8,
		name: "ACH",
		displayName: "ACH",
	},
});

export default FeeTemplatesTypes;
